import { render } from "./SeoAmazonScoreCell.vue?vue&type=template&id=4c6e49fe&scoped=true"
import script from "./SeoAmazonScoreCell.vue?vue&type=script&lang=js"
export * from "./SeoAmazonScoreCell.vue?vue&type=script&lang=js"

import "./SeoAmazonScoreCell.vue?vue&type=style&index=0&id=4c6e49fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6e49fe"]])

export default __exports__